import { FC } from 'react';
import Link from '@base/lib/ThemeLink';
import Iconfont from '@base/lib/Iconfont';
import site from 'pro/config/site';

type SiteSNSProps = {
    className?: string;
}

const iconMap = {
    pinterest: 'icon-official',
    x: 'icon-twitterx'
}

export const SiteSNS: FC<SiteSNSProps> = ({ className }) => {
    return !site.sns ? null : (
        <div className={className}>
            {Object.entries(site.sns).map(([key, url]) => (
                <Link key={key} href={url}>
                    <a aria-label={key} target="_blank" rel="nofollow noopener noreferrer">
                        <Iconfont className={iconMap[key] || `icon-${key}`}/>
                    </a>
                </Link>
            ))}
        </div>
    )
}

export default SiteSNS;